export default {
  steelfish: {
    url: "/assets/fonts/steelfish.otf"
  },
  sunnySpells: {
    url: "/assets/fonts/sunny-spells.ttf"
  }
};